/* Carga em paralelo das partes de uma tela; cada alvo tem o próprio estado de carga e de erro. */

import { state } from '../core/estado';
import { erroBox } from './componentes';

export interface Alvo<T = unknown> {
  /** id do elemento que recebe o HTML. */
  id: string;
  /** Outros elementos que também mostram o erro, se a busca falhar. */
  tambem?: string[];
  busca: () => Promise<T>;
  html: (dados: T) => string;
}

export async function carregar(tk: number, alvos: Alvo<any>[]): Promise<void> {
  await Promise.all(alvos.map(async (a) => {
    try {
      const dados = await a.busca();
      if (tk !== state.tk) return;
      const el = document.getElementById(a.id);
      if (el) el.innerHTML = a.html(dados);
    } catch (e) {
      if (tk !== state.tk) return;
      [a.id, ...(a.tambem || [])].forEach((id) => {
        const el = document.getElementById(id);
        if (el) el.innerHTML = erroBox(e);
      });
    }
  }));
}
